import { gql } from "@apollo/client";

export const manageNotificationSeenMutation = gql`
mutation($manageNotificationSeenId: String!){
  manageNotificationSeen(id: $manageNotificationSeenId) {
    message
  }
}
`;

export const manageAllNotificationSeenMutation = gql`
mutation{
  manageAllNotificationSeen {
    message
    response
  }
}
`;